import { Route } from "../../../types";

export const notFoundRoute: Route = {
  getComponent: (_, cb) => {
    import("./NotFound").then(module => cb(null, module.default));
  },
  path: "*",
  title: "Not Found"
};
